export default {
    state: {
        arr: {}
    },
    getters:{
        APP: state=> {
            return state.arr
        }
    },
    mutations: {
        SET_APP: (state,payload) =>{
            state.arr=payload
            state.arr.actual='1'
        },
        SET_APP_ACTUAL: (state,actual) =>{
            state.arr.actual=actual
        }
    },
    actions: {
        SET_APP: (context, payload) => {
             context.commit('SET_APP',payload)
        },
        SET_APP_ACTUAL: (context, actual) => {
            context.commit('SET_AGE_ACTUAL',actual)
        }
    }

}